import React from "react";
import { Select } from "@shopify/polaris";
import { useCollections } from "../../../api_utils/requests";

interface CollectionSelectProps {
  readonly collectionId: string | undefined;
  readonly setCollectionId: (collectionId: string) => void;
}

export function CollectionSelect({ collectionId, setCollectionId }: CollectionSelectProps): React.ReactElement {
  const { data: collections, isLoading } = useCollections();

  const options = React.useMemo(() => {
    const collectionOptions = collections.map((collection) => ({
      label: collection.title,
      value: collection.id.toString(),
    }));

    return [{ label: "All collections", value: "" }, ...collectionOptions];
  }, [collections]);

  return (
    <Select
      disabled={isLoading}
      label="Collection"
      onChange={setCollectionId}
      options={options}
      value={collectionId || ""}
    />
  );
}
